var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarnPointLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.61035 18.9387C2.61035 17.488 5.90852 16.3127 9.97709 16.3127C14.0456 16.3127 17.3438 17.488 17.3438 18.9387V21.3507C17.3438 22.8014 14.0456 23.9767 9.97709 23.9767C5.90857 23.9767 2.61035 22.8014 2.61035 21.3507C2.61035 20.5462 2.61035 19.7432 2.61035 18.9387Z",
    fill: "#FE9923"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97709 16.3127C14.0456 16.3127 17.3438 17.488 17.3438 18.9387C17.3438 20.3894 14.0456 21.5647 9.97709 21.5647C5.90857 21.5647 2.61035 20.3894 2.61035 18.9387C2.61035 17.488 5.90857 16.3127 9.97709 16.3127Z",
    fill: "#FECD3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97712 16.3127C14.0457 16.3127 17.3439 17.488 17.3439 18.9387C17.3439 18.951 17.3439 18.9633 17.3425 18.9769C15.9 19.4105 14.0361 19.6722 12.0005 19.6722C8.1092 19.6722 4.84511 18.7164 3.95068 17.428C5.28278 16.7531 7.48614 16.3127 9.97712 16.3127Z",
    fill: "#CEA732"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97731 17.5398C13.2141 17.5398 15.8388 18.1656 15.8388 18.9387C15.8388 19.7104 13.2141 20.3376 9.97731 20.3376C6.7405 20.3376 4.11719 19.7104 4.11719 18.9387C4.11723 18.1656 6.7405 17.5398 9.97731 17.5398Z",
    fill: "#FEA832"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97709 17.5398C13.2139 17.5398 15.8386 18.1656 15.8386 18.9387C15.8386 19.0968 15.7268 19.2509 15.5223 19.3927C14.4533 19.5713 13.2589 19.6722 12.0004 19.6722C8.98587 19.6722 6.34755 19.0982 4.89551 18.242C5.90721 17.822 7.80377 17.5398 9.97709 17.5398Z",
    fill: "#CE8829"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3533 21.862V23.1463C15.5797 23.0604 15.7897 22.9691 15.9832 22.8723V21.8606L15.3533 21.862ZM13.7063 23.6154C13.5031 23.659 13.2932 23.6985 13.0778 23.734V22.5096L13.7063 22.5109V23.6154ZM11.4307 23.9262C11.2235 23.9399 11.0135 23.9522 10.8008 23.9603V22.7918L11.4307 22.7932V23.9262ZM9.15511 23.9603C8.94239 23.9521 8.73108 23.9399 8.52384 23.9262V22.7932L9.15511 22.7919V23.9603ZM6.87816 23.734C6.66272 23.6986 6.45277 23.659 6.24961 23.6154V22.5096L6.87816 22.511V23.734ZM4.60256 23.1463C4.37625 23.0604 4.16489 22.9691 3.97266 22.8723V21.862L4.60256 21.8606V23.1463Z",
    fill: "#C85929"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.122 10.6312V11.3906H21.8814V12.0642H21.122V12.8236H20.4484V12.0642H19.689V11.3906H20.4484V10.6312H21.122ZM4.3106 12.0641H3.55118V12.8236H2.87763V12.0641H2.11816V11.3906H2.87763V10.6311H3.55118V11.3906H4.3106V12.0641Z",
    fill: "#FEA832"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72984 0.291992V1.05146H4.48927V1.72496H3.72984V2.48443H3.0563V1.72496H2.29688V1.05146H3.0563V0.291992H3.72984Z",
    fill: "#FEA832"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63379 14.1516C4.63379 12.7009 7.93196 11.5256 12.0005 11.5256C16.0691 11.5256 19.3673 12.7009 19.3673 14.1516V16.5649C19.3673 18.0143 16.0691 19.1896 12.0005 19.1896C7.93201 19.1896 4.63379 18.0143 4.63379 16.5649C4.63379 15.7605 4.63379 14.9561 4.63379 14.1516Z",
    fill: "#FE9923"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0005 11.5256C16.0691 11.5256 19.3673 12.7009 19.3673 14.1516C19.3673 15.6023 16.0691 16.7776 12.0005 16.7776C7.93201 16.7776 4.63379 15.6024 4.63379 14.1516C4.63379 12.7009 7.93196 11.5256 12.0005 11.5256Z",
    fill: "#FECD3D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0005 11.5256C15.4009 11.5256 18.2628 12.3478 19.1109 13.4645H12.0005V11.5256Z",
    fill: "#CEA732"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0006 12.7527C15.2375 12.7527 17.8608 13.3799 17.8608 14.1516C17.8608 14.9246 15.2375 15.5505 12.0006 15.5505C8.76379 15.5505 6.13916 14.9247 6.13916 14.1516C6.13916 13.3799 8.76379 12.7527 12.0006 12.7527Z",
    fill: "#FEA832"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0005 12.7527C14.1888 12.7527 16.0976 13.0404 17.1039 13.4644H12.0005V12.7527Z",
    fill: "#CE8829"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3753 17.0747V18.3591C17.6016 18.2732 17.813 18.1818 18.0052 18.085V17.0747H17.3753ZM15.7283 18.8295C15.5251 18.8718 15.3151 18.9113 15.0997 18.9467V17.7223L15.7283 17.7237V18.8295ZM13.4527 19.1389C13.2454 19.1539 13.0368 19.1649 12.8241 19.173V18.0059L13.4527 18.0072V19.1389ZM11.1771 19.1731C10.9644 19.1649 10.7544 19.154 10.5472 19.139V18.006H11.1771V19.1731ZM8.90013 18.9467C8.68469 18.9113 8.47474 18.8717 8.27158 18.8295V17.7223L8.90013 17.7237V18.9467ZM6.62453 18.3591C6.39818 18.2732 6.18686 18.1818 5.99463 18.085V17.0747H6.62453V18.3591Z",
    fill: "#C85929"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0003 13.4644C15.7007 13.4644 18.7207 10.4457 18.7207 6.74391C18.7207 3.04214 15.7007 0.0234375 12.0003 0.0234375C8.29849 0.0234375 5.27979 3.04214 5.27979 6.74391C5.27979 10.4457 8.29844 13.4644 12.0003 13.4644Z",
    fill: "#FEDB41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0127 0.0234375C15.7185 0.0302344 18.7209 3.03666 18.7209 6.74391C18.7209 10.4511 15.7185 13.4575 12.0127 13.4644V0.0234375Z",
    fill: "#FFCC33"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0005 11.3074C14.5133 11.3074 16.5639 9.25672 16.5639 6.74389C16.5639 4.22965 14.5133 2.18042 12.0005 2.18042C9.48629 2.18042 7.43701 4.2297 7.43701 6.74389C7.43701 9.25672 9.48625 11.3074 12.0005 11.3074Z",
    fill: "#FEA832"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0127 2.18042C14.5269 2.18726 16.5639 4.22698 16.5639 6.74389C16.5639 9.25944 14.5269 11.3005 12.0127 11.3074V2.18042Z",
    fill: "#FE9923"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6399 6.11125V5.77446C12.6399 5.59778 12.4962 5.45406 12.3194 5.45406H11.8354C11.573 5.45406 11.3595 5.66749 11.3595 5.92989C11.3595 6.19099 11.4201 6.40708 12.164 6.40708C12.7978 6.40708 13.3134 6.9227 13.3134 7.5565C13.3134 8.13213 12.8891 8.61035 12.3372 8.69421V9.47491H11.6637V8.70649C11.1232 8.69763 10.686 8.25527 10.686 7.71199V7.37519H11.3596V7.71199C11.3596 7.88941 11.5033 8.03374 11.68 8.03374H12.1641C12.4265 8.03374 12.6399 7.81971 12.6399 7.55655C12.6399 7.29414 12.4265 7.08072 12.1641 7.08072C11.1833 7.08072 10.6861 6.69353 10.6861 5.92994C10.6861 5.35455 11.1111 4.87656 11.6637 4.79341V4.01294H12.3373V4.78145C12.8771 4.79106 13.3135 5.23244 13.3135 5.77455V6.11135H12.6399V6.11125Z",
    fill: "#FEDB41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnPointLogo);
export default __webpack_public_path__ + "static/media/earn-point-logo.c6f4b0e2afc76921bcfb465b16f8aaab.svg";
export { ForwardRef as ReactComponent };